import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appTestContent]'
})
export class TestContentDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
